module.exports = __webpack_public_path__ + "img/79.9.TU.557f6ddd.png";